import React, { useState, useEffect } from "react";

import { Card, Row, Col, Form, Button } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import reportesEmbarquesService from "../../../../Services/Reportes/ReportesCorresponsalias.Service";
import DataTable from "react-data-table-component";
import { DTOReportesEmbarquesPorImportar } from "../../../../DTO/Reportes/Embarques/DTOReportesEmabarquesPorImportar";
import { CellIcon } from "../../../Utils/CellIcon/CellIcon";

export const EmbarquesPorImportar: React.FC = () => {
    const gridRef = React.useRef<any>(null)
    const [EmbarquesPorImportar, setEmbarquesPorImportar] = useState<DTOReportesEmbarquesPorImportar[]>([]);
    const columnDefs = [
        {name: 'ADUANA', selector: (row: DTOReportesEmbarquesPorImportar) => row.aduana, sortable:true},
        {name: 'TIPO DE EMBARQUE', selector: (row: DTOReportesEmbarquesPorImportar) => row.tipoEmbarque, sortable:true},
        {name: 'DESTINO', selector: (row: DTOReportesEmbarquesPorImportar) => row.destino, sortable:true},
        {name: 'DIAS EN ADUANA', selector: (row: DTOReportesEmbarquesPorImportar) => row.diasEnAduana, sortable:true},
        {name: 'NOMBRE', selector: (row: DTOReportesEmbarquesPorImportar) => row.nombre, sortable:true},
        {name: 'TRAFICO', selector: (row: DTOReportesEmbarquesPorImportar) => row.trafico, sortable:true},
        {name: 'REFERENCIA', selector: (row: DTOReportesEmbarquesPorImportar) => row.referencia, sortable:true},
        {name: 'NO DE PEDIMENTO', selector: (row: DTOReportesEmbarquesPorImportar) => row.noPedimento, sortable:true},
        {name: 'CLAVE DE PADIMENTO', selector: (row: DTOReportesEmbarquesPorImportar) => row.clavePedimento, sortable:true},
        {name: 'TIPO', selector: (row: DTOReportesEmbarquesPorImportar) => row.tipo, sortable:true},
        {name: 'ORDEN DE COMPRA', selector: (row: DTOReportesEmbarquesPorImportar) => row.ordenCompra, sortable:true},
        {name: 'FACTURA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.factura, sortable:true},
        {name: 'PROVEEDOR',  selector: (row: DTOReportesEmbarquesPorImportar) => row.proveedor, sortable:true},
        {name: 'DESCRIPCION',  selector: (row: DTOReportesEmbarquesPorImportar) => row.descripcionMercancia, sortable:true},
        {name: 'LINEA TRANSPORTISTA INTERNACIONAL', selector: (row: DTOReportesEmbarquesPorImportar) => row.lineaTransportistaInternacional, sortable:true},
        {name: 'LINEA NAVIERA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.lineaNaviera, sortable:true},
        {name: 'MAWB',  selector: (row: DTOReportesEmbarquesPorImportar) => row.MAWB, sortable:true},
        {name: 'HAWB',  selector: (row: DTOReportesEmbarquesPorImportar) => row.HAWB, sortable:true},
        {name: 'FECHA DE NOTIFICACION',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaNotificacion.toDateString(), sortable:true},
        {name: 'BULTOS',  selector: (row: DTOReportesEmbarquesPorImportar) => row.bultos, sortable:true},
        {name: 'CANTIDAD DE CONTENEDORES',  selector: (row: DTOReportesEmbarquesPorImportar) => row.cantidadContenedores, sortable:true},
        {name: 'NO. CONTENEDORES',  selector: (row: DTOReportesEmbarquesPorImportar) => row.numerosContenedores, sortable:true},
        {name: 'PESO BRUTO',  selector: (row: DTOReportesEmbarquesPorImportar) => row.pesoBruto, sortable:true},
        {name: 'PESO NETO',  selector: (row: DTOReportesEmbarquesPorImportar) => row.pesoNeto, sortable:true},
        {name: 'INCOTERM',  selector: (row: DTOReportesEmbarquesPorImportar) => row.incoterm, sortable:true},
        {name: 'FECHA ETA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaETA.toDateString(), sortable:true},
        {name: 'FECHA DE ENTRADA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaEntrada.toDateString(), sortable:true},
        {name: 'FECHA DE REVALIDACION GUIA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaRevalidacionGuia.toDateString(), sortable:true},
        {name: 'MONTO USD',  cellRenderer: (params: any) => {return `$ ${params.data.montoUSD}`}},
        {name: 'ORIGEN',  selector: (row: DTOReportesEmbarquesPorImportar) => row.origen, sortable:true},
        {name: 'FRACCION ARANCELARIA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fraccionArancelaria, sortable:true},
        {name: 'DESCRIPCION',  selector: (row: DTOReportesEmbarquesPorImportar) => row.descripcion, sortable:true},
        {name: 'PREFERENCIA ARANCELARIA', selector: (row: DTOReportesEmbarquesPorImportar) => row.preferenciaArancelaria, sortable:true},
        {name: 'ESTATUS', selector: (row: DTOReportesEmbarquesPorImportar) => row.estatus, sortable:true},
        {name: 'OBSERVACIONES', selector: (row: DTOReportesEmbarquesPorImportar) => row.observaciones, sortable:true},
        {name: 'FECHA DE INICIO DE GASTOS DE ALMACENAJE', selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaInicioGastosAlmacenaje.toDateString(), sortable:true},
        {name: 'COSTO DIARIO ALMACENAJE',  cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioAlmacenaje}`}},
        {name: 'COSTO DIARIO CONEXION',  cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioConexion}`}},
        {name: 'TOTAL A PAGAR ALMACENAJE',  cellRenderer: (params: any) => {return `$ ${params.data.totalPagar}`}},
        {name: 'TOTAL PAGAR CONEXION',  cellRenderer: (params: any) => {return `$ ${params.data.totalPagarConexion}`}},
        {name: 'FECHA DE PAGO PEDIMENTO', selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaPagoPedimento.toDateString(), sortable:true},
        {name: 'FECHA DE INSTRUCCIONES', selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaInstrucciones.toDateString(), sortable:true},
        {name: 'HORA DE INSTRUCCIONES', selector: (row: DTOReportesEmbarquesPorImportar) => row.horaInstrucciones, sortable:true},
        {name: 'FECHA DE DESPACHO', selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaDespacho.toDateString(), sortable:true},
        {name: 'DIAS C/PDTO PAGADO', selector: (row: DTOReportesEmbarquesPorImportar) => row.diasCPPagado, sortable:true},
        {name: 'FECHA SALIDA DE CONTENEDORES', selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaSalidaContenedores.toDateString(), sortable:true},
        {name: 'NOMBRE DE PAQUETERIA O TRANSPORTISTA',  selector: (row: DTOReportesEmbarquesPorImportar) => row.nombrePaqueteria, sortable:true},
        {name: 'NO. DE GUIA DE EMBARQUE A DESTINO',  selector: (row: DTOReportesEmbarquesPorImportar) => row.noGuiaEmbarqueDestino, sortable:true},
        {name: 'FECHA DE ENTREGA EN DESTINO FINAL',  selector: (row: DTOReportesEmbarquesPorImportar) => row.fechaEntregaDestinoFinal.toDateString(), sortable:true},
        {name: 'HORA DE ENTREGA EN DESTINO FINAL',  selector: (row: DTOReportesEmbarquesPorImportar) => row.horaEntregaDestinoFinal, sortable:true},
        {name: 'FACTURA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.facturaCorresponsal} idTrafico={params.data.id} proceso={16} ></CellIcon>
        }},
        {name: 'CERTIFICADO DE CALIDAD',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.certificadoCalidad} idTrafico={params.data.id} proceso={15} ></CellIcon>
        }},
        {name: 'PACKING LIST',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.packingList} idTrafico={params.data.id} proceso={18} ></CellIcon>
        }},
        {name: 'HOJA TECNICA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.hojaTecnica} idTrafico={params.data.id} proceso={17} ></CellIcon>
        }},
        {name: 'BL',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.bl} idTrafico={params.data.id} proceso={14} ></CellIcon>
        }},
        {name: 'PEDIMENTO INFORMATIVO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoInformativo} idTrafico={params.data.id} proceso={12} ></CellIcon>
        }, width: '130'},
        {name: 'PEDIMENTO SIMPLIFICADO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoSimplificado} idTrafico={params.data.id} proceso={13} ></CellIcon>
        }, width: '130'},
        {name: 'DODA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.doda} idTrafico={params.data.id} proceso={11} ></CellIcon>
        }, width: '100'},
        {name: 'CUENTA DE GASTOS',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.cuentaGastos} idTrafico={params.data.id} proceso={37} ></CellIcon>
        }, width: '100'},
    ];

    const fetchEmbarquesPorImportar = () => {
        reportesEmbarquesService.getReporteEmbarquesPorImportar()
        .then(res => {
            console.log(res.data)
            setEmbarquesPorImportar(res.data)
        });
    }
    useEffect(() => {
        fetchEmbarquesPorImportar();
    },[])

    const filtraEmbarques = (e: any) => {
        gridRef.current.api.setQuickFilter(e.target.value)
    }

    const exportarEmbarques = () => {
        reportesEmbarquesService.GetExcelPorImportar()
        .then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ReporteEmbarquesPorImportar.xlsx`);
            document.body.appendChild(link);
            link.click();
        })
    }

    return (
        <Card className='mt-2'>
            <Card.Body>
                <Row className="mb-4">
                    <Col>
                        <Button className="me-2" onClick={fetchEmbarquesPorImportar}>Actualizar</Button>
                        <Button onClick={exportarEmbarques}><FaDownload/>&nbsp;Excel</Button>
                    </Col>
                </Row>
                <hr/>
                <Row className="mb-2">
                    <Col xs={5}>
                        <Form.Control
                            type='text'
                            size='sm'
                            placeholder='Search...'
                            onChange={(e) => {
                                filtraEmbarques(e)
                            }}
                        />
                    </Col>
                </Row>
                <div className='pt-2'>
                    <Col xs={12}>
                    <DataTable
                        noHeader
                        defaultSortFieldId={'id'}
                        defaultSortAsc={true}
                        pagination
                        paginationPerPage={15}
                        striped={true}
                        dense={true}
                        highlightOnHover
                        columns={columnDefs}
                        data={EmbarquesPorImportar}
                        /* expandableRows={Perfil === "Administrador" || Perfil === "GEMCO"}
                        expandableRowsComponent={({data}) => {
                            return (
                            <RptFacturasDetail idHeader={data.id} showMsg={
                                (type:string, message: string) => {
                                    showToastMessage(type, message)
                                }
                                }
                            />
                            )
                        }} */
                    />
                    </Col>
                </div>
            </Card.Body>
        </Card>
    );
}